import objects from '../recorders/objects';

function errorFromCMS(dataToTracking) {
  return objects.manage.webErrorTrackingSchema(dataToTracking);
}

export default {
  errorFromCMS,
};